export default __webpack_public_path__ + "static/media/banner.7b6cab84.jpeg";